import { AiOutlineDown } from "react-icons/ai";
import styles from "./GenerateKit.module.css";

export const CategorySelector = ({
  categories,
  categoryDisplayText,
  categoryDropdownOpen,
  setCategoryDropdownOpen,
  categoryDropdownRef,
  expandedCategories,
  isCategorySelected,
  getSelectedSubIds,
  toggleCategoryExpand,
  toggleCategory,
  toggleSubcategory,
}) => {
  return (
    <div className={styles.categoryDropdown} ref={categoryDropdownRef}>
      <button
        type="button"
        className={styles.categoryTrigger}
        onClick={() => setCategoryDropdownOpen((o) => !o)}
      >
        <span
          className={
            !categoryDisplayText ? styles.categoryTriggerPlaceholder : ""
          }
        >
          {categoryDisplayText || "Select categories"}
        </span>
        <AiOutlineDown
          className={`${styles.categoryDropdownIcon} ${
            categoryDropdownOpen ? styles.open : ""
          }`}
        />
      </button>
      {categoryDropdownOpen && (
        <div className={styles.categoryDropdownMenu}>
          {categories.map((category) => {
            const isSelected = isCategorySelected(category._id);
            const isExpanded = expandedCategories.has(category._id);
            const subCats = category.subCategories || [];

            return (
              <div key={category._id}>
                <div
                  className={styles.categoryItem}
                  onClick={() => toggleCategory(category)}
                >
                  <input
                    type="checkbox"
                    className={styles.checkbox}
                    checked={isSelected}
                    onChange={() => toggleCategory(category)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <span>{category.name}</span>
                  {subCats.length > 0 && (
                    <span
                      className={`${styles.categoryExpandIcon} ${
                        isExpanded ? styles.expanded : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleCategoryExpand(category._id);
                      }}
                    >
                      <AiOutlineDown />
                    </span>
                  )}
                </div>
                {isExpanded && subCats.length > 0 && (
                  <div className={styles.subcategoryList}>
                    {subCats.map((sub) => {
                      const selectedSubIds = getSelectedSubIds(category._id);
                      const isSubChecked =
                        isSelected && selectedSubIds.includes(sub._id);
                      return (
                        <div
                          key={sub._id}
                          className={styles.subcategoryItem}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (isSelected) {
                              toggleSubcategory(category._id, sub._id);
                            }
                          }}
                        >
                          <input
                            type="checkbox"
                            className={styles.checkbox}
                            checked={isSubChecked}
                            disabled={!isSelected}
                            onChange={(e) => {
                              e.stopPropagation();
                              if (isSelected) {
                                toggleSubcategory(category._id, sub._id);
                              }
                            }}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <span>{sub.name}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
